angular
  .module('cfn')
  .constant(
    'URL_ECOLOGICAL_FOCUS_AREA_LOAD',
    '/365FarmNet/mod/crop-planning-service/rest/planning/cropsequence/greening/v1.0/'
  )
  .constant(
    'URL_ECOLOGICAL_FOCUS_AREA_SAVE',
    '/365FarmNet/mod/crop-planning-service/rest/planning/cropsequence/greening/v1.0/save'
  )
  .constant('ECOLOGICAL_FOCUS_AREA_FACTORS', {
    hedgeAndTrees: 2.0,
    bufferStrips: 1.5,
    afforestation: 1.0,
    nitrogenFixingCrops: 0.7,
    catchCrops: 0.3,
    calculation: {
      minArea: 15,
      requirementFactor: 0.05
    }
  })
  .factory('EcologicalFocusArea', EcologicalFocusArea);

EcologicalFocusArea.$inject = [
  '$http',
  'ECOLOGICAL_FOCUS_AREA_FACTORS',
  'URL_ECOLOGICAL_FOCUS_AREA_LOAD',
  'URL_ECOLOGICAL_FOCUS_AREA_SAVE'
];
function EcologicalFocusArea(
  $http,
  ECOLOGICAL_FOCUS_AREA_FACTORS,
  URL_ECOLOGICAL_FOCUS_AREA_LOAD,
  URL_ECOLOGICAL_FOCUS_AREA_SAVE
) {
  var ALL_FARMS_ID = '00000000-0000-0000-0000-000000000000';

  function EcologicalFocusArea(resource) {
    var efa = resource || { areasOfHolding: {} };

    _.extend(efa, {
      getCurrentEFA: function() {
        return (
          (efa.areasOfHolding.hedgeAreaAndTreeRowAreaInHa || 0) *
            ECOLOGICAL_FOCUS_AREA_FACTORS.hedgeAndTrees +
          (efa.areasOfHolding.areaWithoutProductionInHa || 0) *
            ECOLOGICAL_FOCUS_AREA_FACTORS.bufferStrips +
          (efa.areasOfHolding.abandonementAreaAndForstAreaInHa || 0) *
            ECOLOGICAL_FOCUS_AREA_FACTORS.afforestation +
          (efa.areasOfHolding.nitrogenBindingCropCultivationAreaInHa || 0) *
            ECOLOGICAL_FOCUS_AREA_FACTORS.nitrogenFixingCrops +
          (efa.areasOfHolding.insideCropCultivationAreaInHa || 0) *
            ECOLOGICAL_FOCUS_AREA_FACTORS.catchCrops
        );
      },
      getTotalArea: function() {
        return (
          (efa.areasOfHolding.hedgeAreaAndTreeRowAreaInHa || 0) +
          (efa.areasOfHolding.areaWithoutProductionInHa || 0) +
          (efa.areasOfHolding.abandonementAreaAndForstAreaInHa || 0) +
          (efa.areasOfHolding.nitrogenBindingCropCultivationAreaInHa || 0) +
          (efa.areasOfHolding.insideCropCultivationAreaInHa || 0)
        );
      },
      save: function() {
        return $http.post(URL_ECOLOGICAL_FOCUS_AREA_SAVE, efa);
      }
    });

    return efa;
  }

  _.extend(EcologicalFocusArea, {
    calculateRequiredEFA: function(totalArea) {
      return (
        (totalArea || 0) *
        ECOLOGICAL_FOCUS_AREA_FACTORS.calculation.requirementFactor
      );
    },
    get: function(year, farmId) {
      return $http
        .get(
          URL_ECOLOGICAL_FOCUS_AREA_LOAD +
            '/' +
            year +
            '/' +
            (farmId || ALL_FARMS_ID)
        )
        .then(function(response) {
          if (response.data) {
            return new EcologicalFocusArea(response.data);
          }
          var efa = new EcologicalFocusArea();
          _.extend(efa, {
            harvestYear: year,
            farmId: farmId || ALL_FARMS_ID
          });
          return efa;
        })
        .catch(function() {
          var efa = new EcologicalFocusArea();
          _.extend(efa, {
            harvestYear: year,
            farmId: farmId || ALL_FARMS_ID
          });
          return efa;
        });
    }
  });

  return EcologicalFocusArea;
}
